
import React, { useState, useEffect } from 'react';
import { Row, Col, Spinner } from 'react-bootstrap';
import Markdown from 'marked-react';
import './nextgpt.scss';

function IdealConversation() {
    let accumulatedData = '';
    let remainedData = null;

    const [genstateIC, setGenstateIC] = useState('notgen');
    const [idealConversationData, setIdealConversationData] = useState('');
    const [isSendtoRM, setSendToRM] = useState(false);

    var idealConversationData_local = localStorage.getItem('idealConversationData_local');
    useEffect(() => {
        if (idealConversationData_local !== null) {
            if (genstateIC ==='notgen'){
                document.getElementById('generatingBtn').style.visibility = 'hidden';
                document.getElementById('generatingBtn').style.display = 'none';
                setSendToRM(true);
            } 
            setIdealConversationData(idealConversationData_local);
        }

    }, [idealConversationData_local])

    const callNextGpt = async (usecase, file) => {
        var dataResponse;

        const formData = new FormData();
        const blob = await fetch(file)
        const data = await blob.blob();
        const transcriptUsed = localStorage.getItem('transcript');
        if (transcriptUsed === 'mixed')
            formData.append('transcript', new File([data], "/bank_rm_transcript_mixed.txt"));
        else 
            formData.append('transcript', new File([data], "/bank_rm_transcript.txt"));

        const accessToken = 'vehzcryR9jKk6ImttBLXQHS_dQn0etD5kdM-yeBQots';
        const apiUrl = 'https://nextgpt.southeastasia.cloudapp.azure.com/_api/api/v1/models/' + usecase + '/session';

        fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
            },
            body: formData
        })
            .then(response => {
                return response.text();
            })
            .then(data => {
                dataResponse = data;
                callSession(data, usecase);
                // console.log(data);
                // setSessionId(data);
                // fun(data, usecase)
            })
            .catch(error => {
                console.error('There was a problem with your fetch operation:', error);
            });

        return dataResponse;
    };

    const callSession = (session_id, usecase) => {
        const accessToken = 'vehzcryR9jKk6ImttBLXQHS_dQn0etD5kdM-yeBQots';
        const apiUrl = 'https://nextgpt.southeastasia.cloudapp.azure.com/_api/api/v1/chat/completions?debug=false&session_id=' + session_id;

        const stream = new ReadableStream({
            start(controller) {
                const processResponse = async (response, controller) => {
                    const reader = response.body.getReader();
                    let { done, value } = await reader.read();
                    while (!done) {
                        processChunk(new TextDecoder().decode(value), controller, usecase);
                        ({ done, value } = await reader.read());
                    }
                };

                fetch(apiUrl, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${accessToken}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "model": usecase,
                        "messages": [
                            {
                                "role": "system"
                            }
                        ],
                        "max_tokens": 1000,
                        "temperature": 0,
                        "stream": true
                    })
                })
                    .then(response => processResponse(response, controller))
                    .catch(error => console.error('Error fetching data:', error));
            }
        });
    };

    const processChunk = (chunk, controller, usecase) => {
        chunk = remainedData + chunk;

        var chunkArray = chunk.split('\n');
        chunkArray.forEach((item, index) => {
            if (item.includes('choices')) {

                const jsonData = item.split('data: ')[1];
                try {
                    const data = JSON.parse(jsonData);
                    if (data.choices.length > 0) {

                        if (data.choices[0].finish_reason === "stop") {
                            document.getElementById('generatingBtn').style.visibility = 'hidden';
                            document.getElementById('generatingBtn').style.display = 'none'; 
                            setSendToRM(true); 
                            return;
                        }

                        const newContent = data.choices[0].delta.content;
                        accumulatedData += newContent;
                        console.log(accumulatedData);
                    }

                } catch (e) {
                    if (e === "[DONE]") {
                        controller.close();
                        return;
                    }
                }
            } else {
                remainedData = item;
                // setRemainedData(item);
                if (usecase === "Bank_Redone Conversation API") {
                    setIdealConversationData(accumulatedData);
                    localStorage.setItem('idealConversationData_local', accumulatedData);
                    
                }
            }
        });
    };
    const idealConversation = () => {
        toggleGenStateIC()
        
        //callNextGpt("Bank_Redone Conversation API", "/bank_rm_transcript.txt");
        const transcriptUsed = localStorage.getItem('transcript');
        if (transcriptUsed === 'mixed')
            callNextGpt("Bank_Redone Conversation API", "/bank_rm_transcript_mixed.txt");
        else 
            callNextGpt("Bank_Redone Conversation API", "/bank_rm_transcript.txt");
    }
    const toggleGenStateIC = () => {
        setGenstateIC(prevState => (prevState === 'notgen' ? 'gen' : 'notgen'));
    };

    return (
        <div>
            <Row className='perf_breakdown'>
                <Col><h5>Ideal Conversation</h5></Col>
                <Col className='buttoncol'>
                    <div id="generatingBtn">  
                        <button className={`btn ${genstateIC}`} onClick={idealConversation}>
                            {genstateIC === 'notgen' ? (
                                <div className='notgen'>Generate Ideal Conversation</div>
                            ) : (
                                <div className='gen'>
                                    <Spinner animation="border" size="sm" />Generating
                                </div>
                            )}
                        </button>
                    </div>
                    {
                        isSendtoRM === true && 
                        <button className='btn sendToRm_ic' id="sendToRm">Schedule follow-up session with RM</button>
                    } 
                </Col>
            </Row>
            <Row>
                <div className="idealConversationTable">
                    <Markdown>{idealConversationData}</Markdown>
                </div>
            </Row>
        </div>
    )
}

export default IdealConversation;